const patientViewModalTypes = {
  note: "note",
  insuranceNote: "insuranceNote",
};

export default patientViewModalTypes;
